import { useState, useEffect } from 'react';

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const [wasOffline, setWasOffline] = useState(false);
  
  // Network quality detection
  const [effectiveType, setEffectiveType] = useState<string | null>(null);
  const [isSaveDataEnabled, setIsSaveDataEnabled] = useState(false);

  useEffect(() => {
    // Check connection API for network quality
    const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
    
    if (connection) {
      setEffectiveType(connection.effectiveType || null);
      setIsSaveDataEnabled(connection.saveData === true);
      
      const updateConnectionInfo = () => {
        setEffectiveType(connection.effectiveType || null);
        setIsSaveDataEnabled(connection.saveData === true);
      };
      
      connection.addEventListener('change', updateConnectionInfo);
      
      return () => {
        connection.removeEventListener('change', updateConnectionInfo);
      };
    }
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      console.log('Network: Back online');
      setIsOnline(true);
      setWasOffline(false);
    };

    const handleOffline = () => {
      console.log('Network: Went offline');
      setIsOnline(false);
      setWasOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Determine if connection is slow (3g or worse)
  const isSlowConnection = effectiveType ? ['slow-2g', '2g', '3g'].includes(effectiveType) : false;

  return { 
    isOnline, 
    wasOffline, 
    effectiveType, 
    isSlowConnection, 
    isSaveDataEnabled 
  };
}
